/**
 * 公历每个月份的天数普通表
 * @Array Of Property
 * @return Number
 */
export default [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
